import React from "react";
import { withRouter } from "react-router";
import { PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import { MessageUtil } from '../../../../../util/MessageUtil';     
import { LoadUtil } from "../../../../../framework/util/LoadUtil"; 
import { EnvConstants } from "../../../../../EnvConstants";
import { UserUtil } from "../../../../../util/UserUtil"; 
import { BasePage } from "../../../../../framework/pages/BasePage";

import GridFw, { COLUMN_DEFAULT } from '../../../../../framework/grid/GridFw';
import { Button, Popconfirm } from "antd";
import { AgregarEstacionModal } from "../modals/AgregarEstacionModal";
 
import { ParametrosModal } from "../modals/ParametrosModal";
import { RequestUtil } from "../../../../../util/RequestUtil";
import { StorageCacheUtil } from "../../../../../framework/util/StorageCacheUtil";
import { CopyTwoTone } from "@ant-design/icons";
import { EditarEstacionModal } from "../modals/EditarEstacionModal";
 
class PuntosMuestreoSection extends BasePage {
    renderPage(pageApi) {
  
    const getForm_datos_solicitante = () => pageApi.getComponent('form_datosSolicitantes'); 
    const getGridPuntosMuestreo = () => pageApi.getComponent('PuntosMuestreoSection');
      
    const fnDelete = (value, row, index) => {
      getGridPuntosMuestreo().deleteItem(row.key);      
    }

    const fnUpdateItem = (data) => {
        getGridPuntosMuestreo().saveItemEditing();
        const arrMuestreo = getGridPuntosMuestreo().getData();
        console.log(data)
        
        setTimeout(() => { 
            arrMuestreo.forEach(el => {
                if (data.key == el.key) {
                    getGridPuntosMuestreo().updateItem({
                        ...el,
                        id_estacion: data.id_estacion,
                        estaciondes: data.estaciondes,
                        descripcion: data.descripcion,
                    })
                } else {
                    getGridPuntosMuestreo().updateItem(el)
                }
            });
         }, 0)
    }
  
    const form_datosSolicitantes = {
        layout: 'vertical',
        load:{
            queryId: 815,
            search: true,
            hideMessage: true,
            hideMessageError: true,  
            params: { id_doc: pageApi.getParamId() },
            fnOk: (resp) => {
                const tiene_estacion = resp.dataObject?.tiene_estacion;  

                if(tiene_estacion == 0){
                    setTimeout(() => {
                        calcular_estaciones(resp);
                    }, (500));
                } 
            },
        },
        title: '',
        fields:[
            {
                label: '  ',
                fields: [
                    { name: "titulo", label: "Nro. Solicitud", column: 1, readOnly: true },  
                    {type: 'hidden', name: 'id_doc'},  
                    { name: "raz_soc", label: "Empresa", column: 4, readOnly: true }, 
                    { name: "solicitante", label: "Solicitante", column: 4, readOnly: true }, 
                    { name: "servicio", label: "Tipo Servicio", column: 4, readOnly: true }, 
                ]   
            }
        ],
        onComponentLoad : (formApi, pageApi) =>{
            if (pageApi.getPageMode() !== PAGE_MODE.NEW)
                formApi.load();
        } 
    }

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
        let obj = {};
        obj = {
            fnUpdateItem, 
            data: {
                ...data,
                id_tipo_matriz: getGridPuntosMuestreo()?.itemEditing?.id_tipo_matriz,
                id_empresa: getForm_datos_solicitante().getData().id_empresa,
                id_estacion: id_estacion

            },
        };

        return {
            width: 450,
            maskClosable: true,
            closable: false,
            background: 'white',
            component: esNuevo ? <AgregarEstacionModal name={ obj } getParentApi={pageApi.getApi} /> : <EditarEstacionModal name={ obj } getParentApi={pageApi.getApi} />
        }
    };

      let array_estaciones_cliente = [];
    const calcular_estaciones = (items) => { 
        let lst_estaciones = JSON.parse(items.dataObject.lista_estaciones);
        let correlativo = 1;
        lst_estaciones.forEach((e, idx) => {
            for (var i = 1; i <= e.cantidad; i++) {
            if (correlativo > 0 && correlativo < 10) {
                let obj = {
                id: idx,
                numero: "000" + correlativo,
                id_estacion: "",
                descripcion: "",
                coord_f: "",
                coord_n: "",
                wgs: "",
                altitud: "",
                descripcion_grupo: e.descripcion_grupo,
                id_matriz: e.id_matriz,
                id_matriz_evaluacion: e.id_matriz_evaluacion,
                nombre_matriz: e.nombre_matriz,
                matriz_evaluacion: e.matriz_evaluacion,
                id_tipo_matriz: e.id_tipo_matriz,
                id_rel_cot_ana: e.id_rel_cot_ana,
                list_id_rel_cot_ana: e.list_id_rel_cot_ana,
                producto_matriz:e.producto_matriz
                };
                array_estaciones_cliente = [...array_estaciones_cliente, obj];
            }
            if (correlativo >= 10 && correlativo <= 99) {
                let obj = {
                id: idx,
                numero: "00" + correlativo,
                id_estacion: "",
                descripcion: "",
                coord_f: "",
                coord_n: "",
                wgs: "",
                altitud: "",
                descripcion_grupo: e.descripcion_grupo,
                id_matriz: e.id_matriz,
                id_matriz_evaluacion: e.id_matriz_evaluacion,
                nombre_matriz: e.nombre_matriz,
                matriz_evaluacion: e.matriz_evaluacion,
                id_tipo_matriz: e.id_tipo_matriz,
                id_rel_cot_ana: e.id_rel_cot_ana,
                list_id_rel_cot_ana: e.list_id_rel_cot_ana,
                producto_matriz:e.producto_matriz
                };
                array_estaciones_cliente = [...array_estaciones_cliente, obj];
            }
            if (correlativo >= 100 && correlativo <= 999) {
                let obj = {
                id: idx,
                numero: "0" + correlativo,
                id_estacion: "",
                descripcion: "",
                coord_f: "",
                coord_n: "",
                wgs: "",
                altitud: "",
                descripcion_grupo: e.descripcion_grupo,
                id_matriz: e.id_matriz,
                id_matriz_evaluacion: e.id_matriz_evaluacion,
                nombre_matriz: e.nombre_matriz,
                matriz_evaluacion: e.matriz_evaluacion,
                id_tipo_matriz: e.id_tipo_matriz,
                id_rel_cot_ana: e.id_rel_cot_ana,
                list_id_rel_cot_ana: e.list_id_rel_cot_ana,
                producto_matriz:e.producto_matriz
                };
                array_estaciones_cliente = [...array_estaciones_cliente, obj];
            }
            if (correlativo >= 1000 && correlativo <= 9999) {
                let obj = {
                id: idx,
                numero: "" + correlativo,
                id_estacion: "",
                descripcion: "",
                coord_f: "",
                coord_n: "",
                wgs: "",
                altitud: "",
                descripcion_grupo: e.descripcion_grupo,
                id_matriz: e.id_matriz,
                id_matriz_evaluacion: e.id_matriz_evaluacion,
                nombre_matriz: e.nombre_matriz,
                matriz_evaluacion: e.matriz_evaluacion,
                id_tipo_matriz: e.id_tipo_matriz,
                id_rel_cot_ana: e.id_rel_cot_ana,
                list_id_rel_cot_ana: e.list_id_rel_cot_ana,
                producto_matriz:e.producto_matriz
                };
                array_estaciones_cliente = [...array_estaciones_cliente, obj];
            }
            correlativo++;
            }
        });
        let array_est_mod = array_estaciones_cliente.map((x, i) => {
            x.id = i;
            return x;
        });
        
        getGridPuntosMuestreo().addItem(array_est_mod || []); 
    };

        const ConfiguracionModalConfig = (data) => {
            let obj = {};
            obj = {...obj, data};
            obj = {...obj, id_doc_cotizacion: getForm_datos_solicitante()?.getData()?.id_doc_cotizacion}
            return {
                width: 1200,
                maskClosable: false,
                component: <ParametrosModal name={ obj } getParentApi={pageApi.getApi} />
            }
        };

    let array_estacion_select = []; 
    const grid_puntosMuestreo = {
        title: 'Detalle de Estaciones / Análisis',
        rowId: 'id_rel_ss_estacion',
        showIndex: true,
        pagination: { server: false,showSizeChanger: true, pageSize: 100, size: "small"  },
        autoLoad: true,
        collapsible: false,
        load: {
            validation: () => pageApi.getParamId()!=null, //solo se dispara si el valor es distinto de nulo
            queryId: 845, 
            params: {id_doc: pageApi.getParamId()}, 
            hideMessage: true, 
            hideMessageError: true, 
        },   
        save: {
            queryId: 235,
            params: {est_tab : 4,id_doc : pageApi.getParamId(), id_user: UserUtil.getUserId()},
            fnOk: (resp) => {
                const id = this.props.match.params.id || 0;

                if (parseInt(id) > 3) {
                    this.props.cambiarTabPanel("4", pageApi.getParamId()); 
                } else {
                    this.props.history.push(`/servicios-ejecutados/servicios-ejecutados/4/${pageApi.getParamId()}`)
                    this.props.cambiarTabPanel("4", pageApi.getParamId()); 
                }
                
                return MessageUtil(
                    "success",
                    "Exito!",
                    "Se ha habilitado Datos de Envio de la Muestra"
                ); 
            }, 
            hideMessage: true, 
            hideMessageError: true, 
        },
        expandableAsync: async (record) => {
            let obj = {...record, id_doc_cotizacion: getForm_datos_solicitante()?.getData()?.id_doc_cotizacion}
            const reqParams = LoadUtil.getReqParams({
                queryId: 311,
                params: () => ({
                    id_rel_ss_estacion: obj.id_rel_ss_estacion || 0,
                    id: obj.id,
                    grupo: obj.descripcion_grupo,
                    id_doc_cotizacion: obj.id_doc_cotizacion,
                    id_matriz: obj.id_matriz,
                    id_rel_cot_ana: obj.id_rel_cot_ana,
                    ID_FILA: obj.key,
                }),
            });

            const api = await RequestUtil.postData(EnvConstants.GET_URL_READ(), reqParams)
            .then((resp) => resp.dataList)
            .catch(() => []);

            return (
                <table>
                    <thead>
                    <tr>
                        <th>Parámetro</th>
                        <th>Acreditador</th>
                        <th>Sub Parametros</th>
                    </tr>
                    </thead>
                    <tbody>
                    {api.map((el, idx) => (
                        <tr key={idx}>
                            <td>{el.analisis_concat}</td>
                            <td>{el.acreditacion}</td>
                            <td>{el.parametrosDes}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            );
        },
        fields:[
            {name:'descripcion_grupo', label:'Descripcion'},
            {name:'producto_matriz', label:'Producto'},
            {name:'nombre_matriz', label:'Matriz'},
            {name:'numero', label:'Nro°'},
            // {name:'acreditador', label:'Acreditador'},
            {type: 'select', name: 'id_estacion', 
                 label: () => (
                    <>
                        Estación Muestreo
                        <Button
                            type="success"
                            size='small'
                            title="Replicar"
                            style={{ marginLeft: '5px' }}
                            icon={<CopyTwoTone />}
                            onClick={async () => {
                                await getGridPuntosMuestreo().saveItemEditing();
                                const data = getGridPuntosMuestreo().getData();
                                if(data?.length) {
                                    const firstDate = data[0];
                                    data.forEach(el => {
                                        getGridPuntosMuestreo().updateItem({ 
                                            ...el, 
                                            id_estacion: firstDate.id_estacion, 
                                            estaciondes: firstDate.estaciondes 
                                        })
                                    })
                                }
                            }}
                        />
                    </>
                ), editable: true, labelName:'estaciondes',
            load:{
                queryId: 846,
                params: () => { return { id_empresa: getForm_datos_solicitante().getData().id_empresa, id_tipo_matriz: getGridPuntosMuestreo()?.itemEditing?.id_tipo_matriz }},
                fnOk: (rpta) => {
                    array_estacion_select = rpta.dataList;
                }
            },
            search: true,
            onChange : (value, values, formApi) => {
                if(value == 0) {
                    pageApi.showModal(ConfigEstacionModal(formApi.getData(), true))
                    formApi.setFieldData('id_estacion',null);
                    formApi.setFieldData('descripcion',null);
                } else if (value == -1) {
                    const id_estacion = getGridPuntosMuestreo()?.itemEditing.id_estacion
                    const estaciondes = getGridPuntosMuestreo()?.itemEditing.estaciondes

                    if (!estaciondes) {
                        formApi.setFieldData('id_estacion',null);
                        formApi.setFieldData('estaciondes',null);
                        formApi.setFieldData('descripcion',null);
                        return MessageUtil(
                            "warning",
                            "Advertencia",
                            "Debe seleccionar primero una estaciòn para poder editar."
                        ); 
                    }

                    fnUpdateItem({ ...formApi.getData(), id_estacion, estaciondes })
                    pageApi.showModal(ConfigEstacionModal({...formApi.getData(), id_estacion, estaciondes}, false, id_estacion))
                    formApi.setFieldData('id_estacion',id_estacion);
                    formApi.setFieldData('estaciondes',estaciondes);
                } else {
                    // console.log(getGridPuntosMuestreo().itemEditing.id_estacion, formApi.values.id_estacion, value)
                    if(getGridPuntosMuestreo().itemEditing.numero === formApi.values.numero){
                        const id_estacion = value;
                        let label = formApi?.getFieldApi('id_estacion')?.getSelectedItem()?.label;
                        let descripcion = formApi?.getFieldApi('id_estacion')?.getSelectedItem()?.descripcion;
                        
                        formApi.setFieldData('id_estacion',value);
                        formApi.setFieldData('estacionDes',label || formApi.values.label);
                        formApi.setFieldData('descripcion',descripcion || formApi.values.descripcion);
                        if (formApi.values.id_estacion !== value) {
                            fnUpdateItem({ ...formApi.getData(), id_estacion, estaciondes: label, descripcion })
                        }
                        // console.log(value, values, formApi.getData())
                    }
                }
            }}, 
            {
                type: 'text',
                name: 'descripcion',
                label: 'Descripción',
                editable: true,
                readOnly: true
            },
            {
                type: 'select',    
                name:'id_tipo_certificacion', 
                label: () => (
                    <>
                        Normativa
                        <Button
                            type="success"
                            size='small'
                            title="Replicar"
                            style={{ marginLeft: '5px' }}
                            icon={<CopyTwoTone />}
                            onClick={async () => {
                                await getGridPuntosMuestreo().saveItemEditing();
                                const data = getGridPuntosMuestreo().getData();
                                if(data?.length) {
                                    const firstDate = data[0];
                                    data.forEach(el => {
                                        getGridPuntosMuestreo().updateItem({ 
                                            ...el, 
                                            id_tipo_certificacion: firstDate.id_tipo_certificacion,
                                            tipo_certificacion: firstDate.tipo_certificacion,
                                            
                                        })
                                    })
                                }
                            }}
                        />
                    </>
                ),
                maxVisible: 2, 
                multiple:true,  
                multipleInString: true, 
                editable: true, width: 200, column: 12, 
                labelName:'tipo_certificacion',
                load:{
                    queryId: 768,
                        params: () => {  return { id_matriz_evaluacion_default: getGridPuntosMuestreo()?.itemEditing?.id_matriz_evaluacion,
                            id_matriz_evaluacion: getGridPuntosMuestreo()?.itemEditing?.id_matriz_evaluacion,
                         }},
                }, 
                onChange: (value, values, formApi) => { 
                         formApi.values.id_tipo_certificacion = value;
                            getGridPuntosMuestreo().refresh();
                 

                    // if(formApi.values.id_tipo_certificacion != value){
                    //     formApi.values.id_tipo_certificacion = value;
                    //     getGridPuntosMuestreo().saveItemEditing();
                    //        getGridPuntosMuestreo().refresh();
                    // }

                    // let label = formApi?.getFieldApi('tipo_certificacion')?.getSelectedItem()?.label;
                    //    let umLabel = getGridPuntosMuestreo().getFieldApi('um_id').getSelectedItem().label; 
                    //   if(formApi.values.id_tipo_certificacion == "") {
                    //       formApi.values.tipo_certificacion = "";
                    //   }
                    //   getGridPuntosMuestreo().updateItem(  
                    //      { 
                    //          ...formApi.values,
                    //          id_tipo_certificacion : value
                    //      }
                    //   ); 
                 
                },  
              
            },
            {...COLUMN_DEFAULT.DELETE, title: 'Eliminar', color: 'red', colSpan:0, onClick: fnDelete}
        ],
        // barHeader: bar_header
    };
 
    const barButtonFooter_dat_emision_InfFac = {
        fields: [ 
            { ...BUTTON_DEFAULT.RETURN, link: () => {
                const path = sessionStorage.getItem("ruta_retorno_ejecutar_servicio");
                sessionStorage.removeItem("ruta_retorno_ejecutar_servicio")
                return path;
            }, alert: true, message: 'Está seguro de retornar?', },
            { ...BUTTON_DEFAULT.SAVE, label: "Guardar y Continuar",onClick: () => { getGridPuntosMuestreo().save() } },  
        ]
    }
  
    return (
      <> 
        <FormFw
          name="form_datosSolicitantes"
          getParentApi={pageApi.getApi}
          config={form_datosSolicitantes} 
        />
        
        <div className="detalleEstacionesCliente">
            <GridFw
                name="PuntosMuestreoSection"
                getParentApi={pageApi.getApi}
                config={grid_puntosMuestreo} 
            />
        </div> 
 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter_dat_emision_InfFac} 
        /> 
      </>
    ); 
    } 
} 
export default withRouter(PuntosMuestreoSection)